import { createCRUDHook } from './createCRUDHook';
import { PartAssemblyBrushDto } from 'utils/models';
import { TBL_PART_ASSEMBLY_BRUSH } from './apiEndPoints';

const { Context, useManager, useConsumer } =
  createCRUDHook<PartAssemblyBrushDto>({
    entityName: 'PartAssemblyBrush',
    endpoint: TBL_PART_ASSEMBLY_BRUSH,
  });

export const PartAssemblyBrushContext = Context;
export const usePartAssemblyBrushManager = useManager;
export const usePartAssemblyBrush = useConsumer;
